import React from 'react';

export type TimelineItem = {
  date: string;
  location: string;
  headline: string;
  detail: string;
};

export function TimelineEntry({
  item,
  index,
}: {
  item: TimelineItem;
  index: number;
}) {
  return (
    <li
      className={`timeline-entry ${index % 2 === 0 ? 'timeline-entry--left' : 'timeline-entry--right'}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="timeline-entry__dot" aria-hidden="true" />
      <div className="timeline-entry__content">
        <span className="timeline-entry__date">{item.date}</span>
        <span className="timeline-entry__location">{item.location}</span>
        <h3 className="timeline-entry__headline">{item.headline}</h3>
        <p className="timeline-entry__detail">{item.detail}</p>
      </div>
    </li>
  );
}
